import React from 'react';
const IframePlayer = ({ url, dimensions }) => {
    return (React.createElement("iframe", { "data-hook": "video-iframe-placeholder", className: "gallery-item-content video-iframe-placeholder", title: "pro-gallery-video", style: Object.assign({}, dimensions), allow: 'fullscreen', src: url, allowFullScreen: true, loading: "lazy" }));
};
export default IframePlayer;
//# sourceMappingURL=IframeVideoPlayer.js.map